const serviceConstants = {
    PathConst: {
        'LOCAL_URL': 'localhost:4500',
        'WEB_BASE_URL': (!!window.PrestoPayObj &&
                            !!window.PrestoPayObj.webUrlBase &&
                            window.PrestoPayObj.webUrlBase !== ''
                        ) ? window.PrestoPayObj.webUrlBase : '',
        'API_BASE_URL': (!!window.PrestoPayObj &&
                            !!window.PrestoPayObj.merchantName &&
                            window.PrestoPayObj.merchantName === 'n/a'
                        ) ? 'http://localhost:8282' : '',
        'ONE_PRESTO_BASE_URL': (!!window.PrestoPayObj &&
                            !!window.PrestoPayObj.onePrestoUrlBase &&
                            window.PrestoPayObj.onePrestoUrlBase !== ''
                        ) ? window.PrestoPayObj.onePrestoUrlBase : 'https://one-presto-staging.enovax.com',
        'APP_STORE_LINK': 'https://apps.apple.com/app/id989090200',
        'GOOGLE_PLAY_LINK': 'https://play.google.com/store/apps/details?id=my.elevenstreet.app',
        'APP_GALLERY_LINK': 'https://appgallery.huawei.com/app/C102610979',
    },

    get ApiAddress() {
        return {
            'API_COUNTRY_CODE' : this.PathConst.ONE_PRESTO_BASE_URL +  '/api/mobile-country-code',
            'API_QUERY' : this.PathConst.API_BASE_URL + '/payment/query',
            'API_LOGIN_AS_GUEST' : this.PathConst.API_BASE_URL + '/payment/guest/register',
            'API_LOGIN' : this.PathConst.API_BASE_URL + '/payment/register',
            'API_LOGIN_OTP' : this.PathConst.API_BASE_URL + '/payment/register/otp',
            'API_AUTHORISE_TRANSACTION' : this.PathConst.API_BASE_URL + '/payment/authorise',
            'API_RESEND_OTP' : this.PathConst.API_BASE_URL + '/payment/otp/resend',
            'API_CANCEL_PAYMENT' : this.PathConst.API_BASE_URL + '/payment/cancel',
            'API_LOYALTY_REVALIDATE' : this.PathConst.API_BASE_URL + '/loyalty/revalidate',
            'API_LOYALTY_REGISTER_INIT' : this.PathConst.API_BASE_URL + '/loyalty/register/init',
            'API_LOYALTY_REQUEST_OTP' : this.PathConst.API_BASE_URL + '/loyalty/request-otp',
            'API_TOPUP_OPTIONS' : this.PathConst.API_BASE_URL + '/payment/top-up/options',
            'API_TOPUP_REGISTER' : this.PathConst.API_BASE_URL + '/payment/top-up/register',
            'API_TOPUP_CANCEL' : this.PathConst.API_BASE_URL + '/payment/top-up/cancel',
            'API_TOPUP_AUTHORISE' : this.PathConst.API_BASE_URL + '/payment/top-up/authorise',
            'API_TXN_PIN_UPDATE' : this.PathConst.API_BASE_URL + '/account/txn-pin/update',
        };
    },

    fetchData: (apiPath = '', opts = {}) => {
        return (
            fetch(apiPath, {
                method: opts.method || 'POST', // GET, POST, PUT, DELETE, etc.
                headers: opts.header || {
                    'Content-Type': 'application/json',
                    'x-http-token' : window.PrestoPayObj.apiToken
                },
                mode: opts.mode || 'cors', // same-origin, no-cors, cors
                cache: opts.cache || 'no-cache', // default, no-cache, reload, force-cache, only-if-cached
                ...(opts.method !== 'GET' 
                    ? { body: JSON.stringify(opts.data) || JSON.stringify({}) }
                    : {}
                )
            })
                .then(response => response.ok
                    ? response.json()
                    : {error: true, status: response.status}
                )
                .then(data => data)
                .catch(error => ({error: true, status: error}))
        );
    },
};


export default serviceConstants;